import { render } from "./VendorInactive.vue?vue&type=template&id=4cc51ca1"
import script from "./VendorInactive.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorInactive.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Vendor/VendorInactive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cc51ca1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cc51ca1', __exports__)) {
    api.reload('4cc51ca1', __exports__)
  }
  
  module.hot.accept("./VendorInactive.vue?vue&type=template&id=4cc51ca1", () => {
    api.rerender('4cc51ca1', render)
  })

}


export default __exports__